module.exports = "/assets/c84423a38db9eef828fda4b466bf510d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BE.png
// module id = 2356
// module chunks = 0